import * as React from 'react';

import { MAX_FILTER_TEXT_LENGTH, MAX_VISIBLE_FILTERS } from 'bundles/enterprise-admin-messages/constants';
import { truncate } from 'bundles/enterprise-ui/utils';

import _t from 'i18n!nls/admin-dashboard';

import 'css!../__styles__/FilterPills';

import type { FilterOption } from '../types';
import FilterPill from './FilterPill';

export type Props = {
  filterList: FilterOption[];
  emptyText?: string;
  onDelete: (id: string) => void;
};

const FilterPills = (props: Props) => {
  const { filterList, emptyText = _t('No filters added'), onDelete } = props;

  const more = Math.max(0, filterList.length - MAX_VISIBLE_FILTERS);
  const truncatedFilterList = filterList.slice(0, MAX_VISIBLE_FILTERS);

  return (
    <div className="rc-FilterPills">
      {truncatedFilterList.length > 0 ? (
        truncatedFilterList.map((filter: FilterOption) => (
          <FilterPill
            rootClassName="c-filter"
            key={filter.id}
            label={truncate(filter.label, MAX_FILTER_TEXT_LENGTH)}
            type={filter.type}
            onDismiss={() => onDelete(filter.id)}
          />
        ))
      ) : (
        <div className="c-filterEmpty">{emptyText}</div>
      )}
      {more > 0 && <div className="c-filterMore">{_t('+#{more} more', { more })}</div>}
    </div>
  );
};

export default FilterPills;
